import React from 'react'
import axios from 'axios'
import { format } from 'date-fns'
import { Button } from 'reactstrap'
import { Empty } from 'antd';

import { useHistory } from 'react-router-dom'

import { FaExternalLinkAlt, FaSearch } from "react-icons/fa"
import Pagination from "react-js-pagination"
import { useTranslation } from 'react-i18next'
import { SalaryLists, SalarySearchLists } from '../../components/functions/SalarySlip';

import ErrorSwal from '../../components/SwalError'


const pageSize = 5

const Salaries = () => {

    const { t } = useTranslation()
    const history = useHistory()

    const [salaries, setSalaries] = React.useState([])
    const [error, setError] = React.useState(null)
    const [search, setSearch] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(false);
    const cancelToken = React.useRef(null)

    // pagination
    const [page, setPage] = React.useState(1)
    const [total, setTotal] = React.useState(0)

    // const Token = JSON.parse(localStorage.getItem("token"))


    const getData = async (page) => {

        try {

            setIsLoading(true);
            const resp = await SalaryLists(page, pageSize)

          

            // const response = await fetch(`http://localhost:5000/api/salary/?page=${page}&size=${pageSize}`, {
            //     method: 'GET',
            //     headers: {
            //                 "Access-Control-Allow-Origin": "*",
            //                 "Content-type": "Application/json",
            //                 "Authorization": `Bearer ${Token.access_token}`
            //             }
            // })
            // if (response.ok) {
            //     const jsonData = await response.json();
            //     setSalaries(jsonData.PaginationLists.tutorials)
            //     console.log(resp,Token,response,`http://localhost:5000/api/salary/?page=${page}&size=${pageSize}`,jsonData.PaginationLists.tutorials );
            //   } else {
            //     console.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
            //   }

          

            setSalaries(resp.data.PaginationLists.tutorials)
            setTotal(resp.data.PaginationLists.totalItems)
           

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData(page);

        return () => {

            cancelToken.current.cancel();
        };
    }, [page]);

    if (isLoading) {
        // return (
        //     <div className="spinner-border" role="status">
        //         <span className="sr-only">Loading...</span>
        //     </div>
        // )
    }

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber)
    }

    // Set Search Combobox
    const handleChange = (e) => {
        setSearch({
            ...search,
            [e.target.name]: e.target.value
        })
    }

    // Search Data
    const handleClickSubmit = async (e) => {
        e.preventDefault()

        if (search.t_year) {

            await SalarySearchLists(search, page, pageSize)
                .then((response) => {
                    setSalaries(response.data.PaginationLists.tutorials)
                    setTotal(response.data.PaginationLists.totalItems)
                })
                .catch(error => {
                    if (error?.response?.data) {
                        const { data } = error.response
                        setError(data.message)
                    }
                })
        }
        else {
            ErrorSwal({ title: 'Error', text: 'Please enter your information to search.', icon: 'error' })
            getData(page);
        }
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                    <h4 className="card-title"> {t("t_salary")} </h4>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                    <div className="gap-2 d-grid d-md-flex justify-content-md-end">
                                        <div className="mb-3 input-group">
                                            <input type="text" className="form-control" name="t_year" id="t_year" maxLength={4} placeholder={t("t_input_year")} aria-describedby="button-addon2" onChange={handleChange} />
                                            <Button color="primary" type="submit" id="button-addon2" onClick={handleClickSubmit} >
                                                <FaSearch /> {t("b_search")}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                {salaries.length > 0 ? (
                                    <table className="table mb-0 table-lg">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{ width: '25%' }}> {t("t_sp_v_no")} </th>
                                                <th scope="col" style={{ width: '10%' }}> {t("t_month")}  </th>
                                                <th scope="col" style={{ width: '25%' }}> {t("t_year")} </th>
                                                <th scope="col" style={{ width: '20%' }}> {t("t_pm_date")} </th>

                                                <th scope="col" style={{ width: '15%' }}> {t("t_action")} </th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: '0.9rem' }}>
                                            {
                                                salaries.map((data, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-bold-500">{data.SP_VOUCHER_NO}</td>
                                                            <td className="text-bold-500">{data.T_MONTH}</td>
                                                            <td className="text-bold-500">{data.T_YEAR}</td>
                                                            <td className="text-bold-500"> {format(new Date(data.PAYMENT_DATE), 'dd/MM/yyyy')} </td>
                                                            <td>
                                                                <Button color="primary" onClick={() => history.push('/salary/' + data.SP_VOUCHER_NO)} target="_blank">
                                                                    <FaExternalLinkAlt />
                                                                </Button>

                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                ) :
                                    <Empty />
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div className="mt-2">
                                {salaries.length > 0 ? (
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={pageSize}
                                        totalItemsCount={total}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        hideNavigation={true}
                                    />
                                ) :
                                    <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Salaries